import { Text } from 'rebass'
import { space } from 'styled-system'

const Subtitle = props => (
  <Text
    {...props}
    css={[
      `font-size: ${props.fontSize || '11px'} !important; 
            font-weight: 500 !important;
            color: #abacaf;
            letter-spacing: 0.5px;
            text-align: ${props.textAlign || 'center'};
            text-transform: uppercase;`,
      space
    ]}>
    {props.children}
  </Text>
)

export default Subtitle
